// extracted by mini-css-extract-plugin
export default {"noAccess":"UserCard-module__noAccess--SnFLn","footer":"UserCard-module__footer--MaEmJ","animatedBackground":"UserCard-module__animatedBackground--4NjNa"};